module.exports = __webpack_public_path__ + "img/foot_head.c6e988ce.png";